import {ReservationPeriod, ReservePaymentCalculatorDuration} from './ReservePaymentCalculatorDuration'
import {BusinessSchedule} from '../../facilities/FacilityForReservation'
import {BusinessScheduleWithDateTime} from '../ReserveFacilityPaymentModel'

export class ReservePaymentCalculatorDurationStraddle extends ReservePaymentCalculatorDuration {

    protected adjustPeriodBySchedule(
        schedule: BusinessScheduleWithDateTime | BusinessSchedule,
        period: ReservationPeriod,
    ): ReservationPeriod {
        return period
    }
}
